import gql from "graphql-tag"

export default gql`
  query subtitleSearch($mediaId: String!, $language: String!, $forcedOnly: Boolean!) {
    results: subtitleSearch(mediaId: $mediaId, language: $language, forcedOnly: $forcedOnly) {
      fileId
      language
      fileName
      release
      featureTitle
      year
      hearingImpaired
      forced
      trusted
      machineTranslated
      aiTranslated
      downloadCount
      rating
      matchType
    }
  }
`
